export const configurationConstants = {

    GET_CONFIGURATION_REQUEST: "GETCONFIGURATION_REQUEST",
    GET_CONFIGURATION_SUCCESS: "GETCONFIGURATION_SUCCESS",
    GET_CONFIGURATION_FAILURE: "GETCONFIGURATION_FAILURE",

    CLEAR_CONFIGURATION: 'CLEAR_CONFIGURATION'
};
